export default __webpack_public_path__ + "static/media/bannerFeiraoCarnaval.5aa43767.jpg";